_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
Storage = require 'app/scripts/lib/storage'
{ verticals } = require 'app/scripts/views/onboarding/constants'
Language = require '@trello/locale'

getLocale = ->
  lowerCaseLocale = Language.currentLocale.toLowerCase()
  localeCode = switch
    when lowerCaseLocale == 'zh-tw' then 'zh-hant'
    when lowerCaseLocale == 'zh-cn' then 'zh-hans'
    when lowerCaseLocale == 'zh-hant' then 'zh-hant'
    when lowerCaseLocale == 'zh-hans' then 'zh-hans'
    when lowerCaseLocale == 'pt-br' then 'pt-br'
    else lowerCaseLocale.split('-')[0]

  return localeCode

getTranslatedFile = (fileMap, locale) ->
  localeCode = getLocale()
  fileKeys = Object.keys(fileMap)
  if fileKeys.includes(localeCode)
    return fileMap[localeCode]
  return fileMap['en']

getSavedInspirationBoards = =>
  Storage.get("inspiration-boards") || {}

isInspirationBoard = (boardId) =>
  savedInspoBoards = getSavedInspirationBoards()
  for inspoBoardId, myBoardId of savedInspoBoards
    return true if myBoardId == boardId
  return false

getInspoBoardId = (boardId) =>
  savedInspoBoards = getSavedInspirationBoards()
  for inspoBoardId, myBoardId of savedInspoBoards
    return inspoBoardId if myBoardId == boardId

getVertical = (boardId) =>
  thisInspoBoardId = getInspoBoardId(boardId)
  for vertical, def of verticals
    for lang, board of def.inspirationBoards
      return vertical if board.id == thisInspoBoardId
  return null

removeBoard = (boardId) =>
  savedInspoBoards = getSavedInspirationBoards()
  for inspoBoardId, myBoardId of savedInspoBoards
    if myBoardId == boardId
      delete savedInspoBoards[inspoBoardId]
      Storage.set('inspiration-boards', savedInspoBoards)

copyBoardFromVertical = (modelCache, vertical) =>
  new Promise (resolve, reject) =>
    { id, name } = verticals[vertical].inspirationBoards[getLocale()]

    initialData = {
      name: name
      idOrganization: ''
    }

    requestData = _.extend initialData, {
      creationMethod: 'assisted'
      idBoardSource: id
      keepFromSource: 'cards'
      prefs_permissionLevel: 'private'
    }

    Auth.me().boardList.create initialData, {
      modelCache: modelCache
      requestData: requestData
      success: (board) =>
        savedInspoBoards = getSavedInspirationBoards()

        Storage.set("inspiration-boards", _.extend {}, savedInspoBoards, {
          "#{id}": board.id
        })

        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        Controller.displayBoard({
          idBoard: board.id
        }).done()

        # Remove other inspiration boards from local storage and close them
        for inspoBoardId, myBoardId of savedInspoBoards
          removeBoard(myBoardId)
          ModelCache.get('Board', myBoardId)?.close()

        return resolve()
      error: (err) ->
        Controller.displayErrorPage()
        reject(err)
    }

module.exports = {
  copyBoardFromVertical
  isInspirationBoard
  getVertical
  removeBoard
  getLocale
  getTranslatedFile
}
